<template>
    <div class="enquiry-result">
        <tableList
                rowKey="companyId"
                :loading="false"
                :index-show="true"
                :table-data="tableData"
                :table-label="tableLabel">
        </tableList>
        <!-- <div class="pagination">
            <el-pagination
                    :pager-count="5"
                    :page-sizes="[10, 20, 30]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="queryData.pageNum"
                    :total="total"
                    :page-size.sync="queryData.pageSize"
                    prev-text="上一页"
                    next-text="下一页"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
            ></el-pagination>
        </div> -->
    </div>
</template>

<script>
import tableList from '@/modules/projectA/components/common/e-table-list';
import Api from '@/modules/projectA/api/enquiry';

export default {
  components:{
    tableList
  },
  props:{
    showFlag:{
      type: Boolean,
      default: true,
    }
  },
  data(){
    return{
      queryData:{
        pageNum:1,
        pageSize:10,
      },
      total:0,
      tableData:[],
      tableLabel: [
        // {label: '序号', slot: 'showIndex', align: 'center',width:'80'},
        {label: '品名',param: 'productName', align: 'center',},
        {label: '材质',param: 'material', align: 'center',},
        {label: '规格',param: 'specifications', align: 'center',},
        {label: '标准',param: 'standardType', align: 'center',},
        {label: '品牌',param: 'brandName', align: 'center',},
        {label: '数量',param: 'requiredQuantity', align: 'center',},
        {label: '计量单位',param: 'unitName', align: 'center',},
        {label: '交货期',param: 'deliveryDate', align: 'center',},
        {label: '备注',param: 'remark', align: 'center',},
        {label: '中选方',param: 'supplierCompany', align: 'center',},
      ],
    }
  },
  methods:{
    
    async enquiryResultListByEnquiryId(){
      let res = await Api.enquiryResultListByEnquiryId({id:this.$route.query.enquiryId,...this.queryData});
      console.log(res);
      if(res.code === '200' && res.data){
            // const {records = [],total = 0} = res.data;
            this.tableData = res.data || [];
            // this.total = total || 0;
      }
    },
  },
  mounted() {
    // if(!this.showFlag){
    //   this.tableLabel = this.tableLabel.splice(0,11);
    // }
    this.enquiryResultListByEnquiryId();
  }
}
</script>

<style scoped>
.enquiry-result{
  padding: 20px 10px;
  background: #fff;
  margin-bottom: 20px;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.209933);
}
</style>